<template>
  <div>
    <div class="main">
      <div class="video">

      </div>
      <div class="info">
        <div class="name">名称:&nbsp;&nbsp; <span>yushi</span></div>
        <div class="detail">
          <div class="type">类型:&nbsp;&nbsp; <span>视频监控</span></div>
          <div class="brand">类型:&nbsp;&nbsp; <span>视频监控</span></div>
          <div class="model">类型:&nbsp;&nbsp; <span>视频监控</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "VideoShowComp"
}
</script>

<style scoped>
.main {
  margin: 0 10px 20px 0;
  width: 559px;
  height: 488px;
  border: 1px solid #299BFF;
  opacity: 0.8;
  border-radius: 2px;
}

.video {
  margin: 37px 45px 0 45px;
  width: 469px;
  height: 277px;
  background: #299BFF;
  background: rgba(41, 155, 255, 0.1);
  border-radius: 2px;
}

.info {
  margin: 4px 45px 0 45px;
  width: 469px;
  height: 128px;
  background: rgba(41, 155, 255, 0.1);
  border-radius: 2px;
}

.name {
  float: left;
  margin: 29px 0 0 31px;
  height: 19px;
  width: 100%;
  font-weight: bold;
  line-height: 19px;
  color: #299BFF;
  opacity: 1;
}

.detail {
  float: left;
  margin: 20px 31px 0 31px;
  height: 19px;
  width: 100%;
  font-weight: 400;
  line-height: 19px;
  color: #FFFFFF;
  opacity: 1;
}

.detail div {
  width: 28%;
  display: inline-block;
  margin: 0 auto 0 auto;
}
</style>
